import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslation from './locales/en/translation.json';
import idTranslation from './locales/id/translation.json';

i18n
  .use(initReactI18next) // Integrasi dengan React
  .init({
    resources: {
      en: { translation: enTranslation },
      id: { translation: idTranslation },
    },
    lng: 'en', // Bahasa default
    fallbackLng: 'en', // Jika bahasa tidak ditemukan
    interpolation: {
      escapeValue: false, // Tidak perlu di-escape karena React sudah aman
    },
  });

export default i18n;
